import { SagaIterator } from "redux-saga";
import { FetchUploadInstrumentBatchByIdRequest, FetchUploadInstrumentBatchesRequest, InstrumentBatchUploadTypes } from "./types";
import { fetchInstrumentsByBatchIdApi, fetchUploadInstrumentBatchByIdApi, fetchUploadInstrumentBatchesApi } from "./api";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";

function* fetchInstrumentBatchesUpload({ payload }: FetchUploadInstrumentBatchesRequest): SagaIterator {
    try {
        const response = yield call(fetchUploadInstrumentBatchesApi, payload);
        yield put({
            type: InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHES_UPLOAD_SUCCESS,
            payload: { data: response.data.data },
        });
    } catch (error: any) {

        yield put({
            type: InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHES_UPLOAD_ERROR,
            payload: { error: error },
        });
    }
}

function* fetchInstrumentBatchUploadById({ payload }: FetchUploadInstrumentBatchByIdRequest): SagaIterator {
    try {
        const response = yield call(fetchUploadInstrumentBatchByIdApi, payload);
        yield put({
            type: InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID_SUCCESS,
            payload: { data: response.data.data },
        });
    } catch (error: any) {

        yield put({
            type: InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID_ERROR,
            payload: { error: error },
        });
    }
}

function* fetchInstrumentsByBatchId({ payload }: FetchUploadInstrumentBatchesRequest): SagaIterator {
    try {
        const response = yield call(fetchInstrumentsByBatchIdApi, payload);
        yield put({
            type: InstrumentBatchUploadTypes.FETCH_INSTRUMENTS_BY_BATCH_ID_SUCCESS,
            payload: { data: response.data.data },
        });
    } catch (error: any) {

        yield put({
            type: InstrumentBatchUploadTypes.FETCH_INSTRUMENTS_BY_BATCH_ID_ERROR,
            payload: { error: error },
        });
    }
}

export function* watchFetchUploadInstrumentBatches() {
    yield takeEvery(InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHES_UPLOAD, fetchInstrumentBatchesUpload);
}

export function* watchFetchUploadInstrumentBatchById() {
    yield takeEvery(InstrumentBatchUploadTypes.FETCH_INSTRUMENT_BATCHE_UPLOAD_BY_ID, fetchInstrumentBatchUploadById);
}

export function* watchFetchInstrumentByBatchId() {
    yield takeEvery(InstrumentBatchUploadTypes.FETCH_INSTRUMENTS_BY_BATCH_ID, fetchInstrumentsByBatchId);
}

function* instrumentBatchUploadSaga(){
    yield all([
        fork(watchFetchUploadInstrumentBatches),
        fork(watchFetchUploadInstrumentBatchById),
        fork(watchFetchInstrumentByBatchId),
    ]);
}

export default instrumentBatchUploadSaga;